import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { DeviceListingFieldName } from 'src/app/pages/equipment/devices/components/devices.models';
import { AlarmListingFieldName } from '../services/alarms.types';

export const ALARMS_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALL,
    value: 1,
    types: [
      DeviceListingFieldName.SerialNumber,
      DeviceListingFieldName.CommDeviceId,
      DeviceListingFieldName.ModelName,
      AlarmListingFieldName.AlarmName
    ],
    hintText: SEARCH_HINTS.Search
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALARM_NAME,
    value: 2,
    types: [AlarmListingFieldName.AlarmName],
    hintText: SEARCH_HINTS.AlarmName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 3,
    types: [DeviceListingFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.MODEL_NAME,
    value: 4,
    types: [DeviceListingFieldName.ModelName],
    hintText: SEARCH_HINTS.ModelName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERIAL_NUMBER,
    value: 5,
    types: [DeviceListingFieldName.SerialNumber],
    hintText: SEARCH_HINTS.SerialNumber
  }
];

export const ALARMS_DEFAULT_SEARCH_TYPE: SearchType = ALARMS_SEARCH_TYPES[0];
